<div class="description-object-type">
  <div class="top-part">
    <div class="header">
      <span>
        {{ 'module.energyMap.descriptionComponent.editBuildingDetailsText' | translate }}
      </span>
    </div>
  </div>

  <div class="body-container">
    <div class="description-address">
      <div class="address-section">
        <label>{{ 'module.energyMap.descriptionComponent.address' | translate }}</label>
        <div></div>
      </div>

      <div class="contact-section">
        <label>{{ 'module.energyMap.descriptionComponent.contactNumbers' | translate }}</label>
        <div></div>
      </div>
    </div>

    <div *ngIf="editType === 1" class="description-types">
      <label class="description-type-label">
        {{ 'module.energyMap.descriptionComponent.objectTypes' | translate }}
      </label>

      <div class="btn-group" dropdown>
        <mat-form-field class="dropdown-toggle" floatLabel="never">
          <mat-label>{{ 'module.energyMap.descriptionComponent.editBuildingDetailsText' | translate }}</mat-label>
          <mat-select
            matNativeControl
            required
            [formControl]="nativeSelectFormControl"
            panelClass="my-select-panel-class"
            *ngIf="!!authService.permissions.BUILDING_TYPE_READ || !!authService.permissions.BUILDING_TYPE_WRITE"
            [disabled]="!!!authService.permissions.BUILDING_TYPE_WRITE"
          >
            <mat-option
              role="menuitem"
              *ngFor="let buildingType of buildingTypes"
              value="{{ buildingType.name }}"
              href="javascript:void(0);"
              (click)="setType(buildingType)"
              >{{ buildingType.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="editType === 2" class="description-gps">
      <label class="description-gps-label">
        {{ 'module.energyMap.descriptionComponent.gpsLocation' | translate }}
      </label>
      <div>
        <div class="instruction-item">
          <div class="badge">1</div>
          <div class="gps-instruction">{{ 'module.energyMap.descriptionComponent.gpsInstruction1' | translate }}</div>
        </div>

        <div>
          <span class="badge">2</span>
          <span class="gps-instruction">{{ 'module.energyMap.descriptionComponent.gpsInstruction2' | translate }}</span>
        </div>

        <div>
          <span class="badge">3</span>
          <span class="gps-instruction">{{ 'module.energyMap.descriptionComponent.gpsInstruction3' | translate }}</span>
        </div>

        <div>
          <span class="badge">4</span>
          <span class="gps-instruction">{{ 'module.energyMap.descriptionComponent.gpsInstruction4' | translate }}</span>
        </div>

        <div>
          <span class="badge">5</span>
          <span class="gps-instruction">{{ 'module.energyMap.descriptionComponent.gpsInstruction5' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="object-location-container" *ngIf="!!authService.permissions.BUILDING_LOCATION_UPDATE">
      <button (click)="showObjectLocation()" *ngIf="editType === 2" class="btn btn-primary">
        <span class="fa fa-map-marker" aria-hidden="true"></span>
        <span class="btn-text">{{ 'module.energyMap.descriptionComponent.locateObject' | translate }}</span>
      </button>
    </div>

    <label>{{ 'module.energyMap.descriptionComponent.comments' | translate }}</label>
    <textarea
      class="description-input"
      rows="5"
      cols="50"
      [(ngModel)]="data.description"
      maxlength="250"
      [disabled]="!!!authService.permissions.BUILDING_TYPE_WRITE"
    >
    </textarea>
  </div>

  <div class="bottom-buttons">
    <button (click)="save()" class="btn btn-primary">
      <span class="fa fa-save" aria-hidden="true"></span>
      <span class="btn-text">{{ 'module.energyMap.descriptionComponent.saveChanges' | translate }}</span>
    </button>
    <button class="btn btn-white">
      <span class="btn-text">{{ 'module.energyMap.descriptionComponent.abort' | translate }}</span>
    </button>
  </div>
</div>
